import styled from '@emotion/styled';
import {Button as SharedButton} from '@travel-frontend/ui-components';

export const Button = styled(SharedButton)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${({theme}) => theme.stacking.zIndexControls};
  width: var(--width);
  max-width: calc(100vw - var(--margin) * 2);
  /* fixes shared button transitioning "all", including geometry */
  transition: background 100ms;
  ${({theme}) => theme.elevations.large};
`;
